import DomainEntity from '@/models/DomainEntity'

export default class StateBuildings extends DomainEntity {
  static get collectionName() {
    return 'statebuildings/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
